<template>
  <div class="col-md-12 storage_components_list">
    <div
        class="main_filters"
        :class="filters_state ? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span class="mdi" :class="filters_state ? 'mdi-filter-remove' : 'mdi-filter'" />
      <span class="main_fiters_toggler_text">
        {{ filters_state ? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state ? 'shown' : 'hidden'">
        <div class="form_select" v-for="key in ['q', 'store_id', 'assortment_id']" :key="key">
          <fg-input
              v-model="filter[key]"
              type="text"
              :label="translate('storage.components.' + key)"
              :placeholder="translate('storage.components.' + key)"
              :clearable="true"
          />
        </div>
        <div class="form_select"></div>
        <div class="form_select"></div>
      </div>
    </div>

    <div class="response_table">
      <div class="spinner" v-if="loading"><scale-loader /></div>
      <p v-else-if="!components_list.length">{{ translate('no_data') }}</p>
      <table v-else>
        <thead>
          <tr>
            <th
                v-for="column in columns" :key="column" scope="col"
                class="pointer" tabindex="0"
                :class="[column_widths[column], { selected: filter_type === column }]"
                :aria-sort="filter_type === column ? (filter_asc === 'asc' ? 'ascending' : 'descending') : 'none'"
                @click="change_filter(column)"
                @keydown.enter="change_filter(column)"
                @keydown.space.prevent="change_filter(column)"
            >
              {{ translate('storage.components.' + column) }}
              <i v-if="filter_type === column" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in component_list" :key="key">
            <td
                v-for="column in columns"
                :key="column"
                :data-label="translate('storage.components.' + column)"
                :class="[column_widths[column], { 'text-left': column === 'assortment_name', 'text-right': ['stock', 'reserve', 'in_transit', 'available'].includes(column) }]"
            >
              {{ item[column] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StorageComponentsList',
  data () {
    return {
      components_list: [],
      filter_type: '',
      filter_asc: 'asc',
      columns: ['assortment_name', 'assortment_code', 'article', 'stock', 'reserve', 'in_transit', 'available'],
      column_widths: {assortment_code: 'w7per', article: 'w10per', stock: 'w7per', reserve: 'w7per', in_transit: 'w7per', available: 'w7per'},
      filter: {q: '', store_id: '', assortment_id: ''},
      loading: false,
      timer: null,
      request_id: 0,
      filters_state: this.localStorage.getItem('filters_state') !== 'false'
    }
  },
  computed: {
    component_list () {
      return [...this.components_list].sort(this.compareNumbers)
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        clearTimeout(this.timer)
        this.request_id++
        this.timer = setTimeout(this.load_components, 300)
      }
    }
  },
  created () {
    this.load_components()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.request_id++
  },
  methods: {
    load_components() {
      if (!this.$store.getters.getPermissions.permissionGod) return
      const request_id = ++this.request_id
      const params = {...this.filter}
      Object.keys(params).forEach(key => {
        if (params[key] === '') delete params[key]
      })
      this.loading = true
      this.$http.v1.getStorageComponentsList(params, (response) => {
        if (request_id !== this.request_id) return
        this.components_list = response.data.data
        this.loading = false
      }, () => {
        if (request_id !== this.request_id) return
        this.loading = false
        this.global_notify('danger', this.translate('storage.components.load_error'))
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.storage_components_list{
  height: 100%;
  display: flex;
  flex-direction: column;
  .main_filters{
    top: 20px;
  }
  .header{
    display: flex;
    align-items: flex-end;
    gap: 10px;
    .form_select{
      flex: 1;
      min-width: 0;
      .form-group{
        margin-bottom: 0;
      }
    }
  }
  .response_table{
    padding-left: 0;
    padding-right: 0;

    th, td{
      font-size: 12px;
    }

    .text-left{
      text-align: left;
    }
    .text-right{
      text-align: right;
    }
  }
}
</style>
